import React, {useState} from 'react'
import {BrowserRouter, Route, Routes} from "react-router-dom"
import MethodSelection from '../method-selection/MethodSelection'
import ScrollToTop from '../misc/ScrollToTop'
import StartVideo from '../start-video/StartVideo'
import StartBasic from '../start-basic/StartBasic'
import StartEId from '../start-eid/StartEId'
import StartAutoId from '../start-autoid/StartAutoId'
import UnexpectedError from '../start-eid/unexpected-error/UnexpectedError'
import IdentSuccess from '../start-eid/ident-success/IdentSuccess'
import PropTypes from "prop-types";
import StartEudiwId from "../start-eudiwid/StartEudiwId";
import EudiwIdPolling from '../start-eudiwid/ident-processing/EudiwIdPolling';
import EudiwIdSuccess from '../start-eudiwid/ident-processing/EudiwIdSuccess';
import EudiwIdError from '../start-eudiwid/ident-processing/EudiwIdError';

const ROUTER_BASE_PATH = process.env.PUBLIC_URL
const IS_MOBILE_DEVICE = /ipad|iphone|android/.test(navigator.userAgent.toLowerCase()) && !window.MSStream

export default function CaseInfo({caseInfo, queryParams, tcTokenUrlHost}) {
    const [browserInfo, setBrowserInfo] = useState({isMobileDevice: IS_MOBILE_DEVICE, checkedVideo: false})
    const [couponData, setCouponData] = useState()

    return <BrowserRouter basename={ROUTER_BASE_PATH}>
        <ScrollToTop>
            <Routes>
                <Route path="basic/*" element={
                    <StartBasic
                      caseInfo={caseInfo}
                      isMobileDevice={browserInfo.isMobileDevice}
                      couponData={couponData}
                      setCouponData={setCouponData} />
                } />
                {["npa/*", "eid/*"].map(path => <Route key={path} path={path} element={
                    <StartEId
                      caseInfo={caseInfo}
                      isMobileDevice={browserInfo.isMobileDevice}
                      tcTokenUrlHost={tcTokenUrlHost} />
                } />)}
                <Route path="autoid/*" element={
                    <StartAutoId
                      caseInfo={caseInfo}
                      isMobileDevice={browserInfo.isMobileDevice} />
                }/>
                <Route path="eudiwid/*" element={
                    <StartEudiwId
                        caseInfo={caseInfo}
                        isMobileDevice={browserInfo.isMobileDevice} />
                }/>
                <Route path="eudiwid/processing" element={<EudiwIdPolling caseInfo={caseInfo} />} />
                <Route path="eudiwid/success" element={<EudiwIdSuccess caseInfo={caseInfo} />} />
                <Route path="eudiwid/error" element={<EudiwIdError caseInfo={caseInfo} />} />
                <Route path="eIdError/*" element={
                    <UnexpectedError
                      caseInfo={caseInfo}
                      caseId={caseInfo.caseId}
                      isMobileDevice={browserInfo.isMobileDevice} />
                } />
                <Route path="eIdSuccess/*" element={
                    <IdentSuccess
                        caseId={caseInfo.caseId}
                        caseInfo={caseInfo}/>
                } />
                <Route path="video/*" element={
                    <StartVideo
                      caseInfo={caseInfo}
                      browserInfo={browserInfo}
                      setBrowserInfo={setBrowserInfo} />
                } />
                <Route path="*" element={
                    <MethodSelection
                      caseInfo={caseInfo}
                      search={queryParams} />
                } />
            </Routes>
        </ScrollToTop>
    </BrowserRouter>
}

CaseInfo.propTypes = {
    caseInfo: PropTypes.shape({
        caseId: PropTypes.string.isRequired
    }).isRequired,
    queryParams:PropTypes.string,
    tcTokenUrlHost: PropTypes.string.isRequired
}
